import {setIsOnboardingSeen} from './reducer';
import {store} from '../../../redux/store';
import {getLocalData, setLocalData} from '../../../utils/storage';
import {keys} from '../../../api/keys';

/**
 * Hide Onboarding screen.
 */
export const initOnboardingScreen = async () => {
  const isSeen = getLocalData(keys.ONBOARDING);
  store.dispatch(setIsOnboardingSeen({isSeen: !!isSeen}));
};
/**
 * Hide Onboarding screen.
 */
export const hideOnboardingScreen = () => {
  setLocalData(keys.ONBOARDING, true);
  store.dispatch(setIsOnboardingSeen({isSeen: true}));
};
